import { render, staticRenderFns } from "./publicly.vue?vue&type=template&id=22956044&scoped=true&"
import script from "./publicly.vue?vue&type=script&lang=js&"
export * from "./publicly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22956044",
  null
  
)

export default component.exports